<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="group-list-list-view" class="data-list-container">
		<vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="alarms">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<vs-button
					type="filled"
					class="g-btn-customize p-0 btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="$emit('valueCreateSchelude', 1)"
				>
					<span class="btnTextCustom">{{ $t("general.New2") + " " + $t("general.Load") }}</span>
				</vs-button>
			</div>

			<template slot="thead">
				<vs-th class="g-table--title" sort-key="name">N</vs-th>
				<vs-th class="g-table--title" sort-key="name">{{ $t("UploadFiles.UploadType") }}</vs-th>
				<vs-th class="g-table--title" sort-key="category">{{ $t("ObjectType") }}</vs-th>
				<vs-th class="g-table--title" sort-key="popularity">{{ $t("Status") }}</vs-th>
				<vs-th class="g-table--title" sort-key="order_status">{{ $t("ManualData.AddedOn") }}</vs-th>
				<vs-th class="g-table--title">{{ $t("Action") }}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="g-table--description">{{ tr.id }}</p>
						</vs-td>

						<vs-td>
							<p class="g-table--description truncate">
								{{ tr.category_name }}
							</p>
						</vs-td>

						<vs-td>
							<p class="g-table--description">{{ tr.typology_name }}</p>
						</vs-td>

						<vs-td>
							<p class="g-table--description">{{ tr.process_state }}</p>
						</vs-td>

						<vs-td>
							<p class="g-table--description">{{ tr.added_on }}</p>
						</vs-td>

						<vs-td class="g-table--description whitespace-no-wrap">
							<feather-icon
								v-if="uploadfileUpdatePermission && tr.category_name !== 'LAYER'"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								class="g-label--normal"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="uploadfileDeletePermission"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="confirmDeleteAlarm(tr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleAlarm from "@/store/alarm/moduleAlarm";

export default {
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssigGroup: false,
					columns: ["name", "description", "address", "hour_init", "hour_end", "action"],
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			// alarms: [],
			itemsPerPage: 6,
			isMounted: false,

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			fileDelete: null,
		};
	},
	computed: {
		uploadfileReadPermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_R");
		},
		uploadfileCreatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_C");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		uploadfileDeletePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_D");
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		alarms() {
			return this.$store.state.uploadFile.uploadedFiles;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.alarms.length;
		},
	},
	methods: {
		prueba() {
			this.$store.dispatch("uploadFile/downloadFileFormat").then((res) => {
				this.download(res, "file.xlsx", "xls");
			});
		},
		download(data, filename, type) {
			var file = new Blob([data], {type: type});
			if (window.navigator.msSaveOrOpenBlob)
				// IE10+
				window.navigator.msSaveOrOpenBlob(file, filename);
			else {
				// Others
				var a = document.createElement("a"),
					url = URL.createObjectURL(file);
				a.href = url;
				a.download = filename;
				document.body.appendChild(a);
				a.click();
				setTimeout(function () {
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				}, 0);
			}
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		confirmDeleteAlarm(data) {
			this.fileDelete = data;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Record.DeleteRecord"),
				text: `${this.$t("Record.DeleteRecordConfirmText")} ${this.$t("Record.RecordNumber")}: ${
					this.fileDelete.id
				}`,
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.openLoading();
			this.$store
				.dispatch("uploadFile/removeUploadFile", this.fileDelete.id)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Record.DeleteRecord"),
						text: this.$t("Record.TextConfirmRecordDelete"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					throw new Error(err);
				})
				.finally(() => {
					this.closeLoading();
				});
		},
		editData(data) {
			this.$router.push({name: `app-manual-data`, params: {id: data.id}}).catch(() => {});

			//this.$emit("selectedUploadFileEmit", data);
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		cahngeCurrentPageLocal() {
			this.currentPageLocal = 1;
			/*  this.getGroups({page:val, quantity: this.itemsPerPage})   */
		},
	},
	watch: {
		itemsPerPage(val) {
			/*  this.getGroups({page:1, quantity: val}) */
			this.currentPageLocal = 1;
		},
	},
	created() {
		if (!moduleAlarm.isRegistered) {
			this.$store.registerModule("moduleAlarm", moduleAlarm);
			moduleAlarm.isRegistered = true;
		}
		const payload = {
			page: 1,
			quantity: 100,
			id: [],
			category_id: null,
			process_state: "FINALIZED",
			order_by: "added_on",
			sort: "DESC",
		};
		this.$store.dispatch("uploadFile/getUploadFilter", payload);
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
#group-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.5rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
